import { create } from "zustand";
import { persist } from "zustand/middleware";
import AudioManager from "../utils/AudioManager";

// a minimal wrapper so the API matches
const webStorage = {
  getItem: (name) => Promise.resolve(localStorage.getItem(name)),
  setItem: (name, value) => Promise.resolve(localStorage.setItem(name, value)),
  removeItem: (name) => Promise.resolve(localStorage.removeItem(name)),
};

export const useSoundsStore = create(
  persist(
    (set, get) => ({
      sfxVolume: 0.05,
      musicVolume: 0.05,
      isMusicMuted: false,
      isSfxMuted: false,
      soundBank: {},
      musicBank: {},
      soundsReady: false,
      musicReady: false,

      // ---- actions ----
      setSoundBank: (newBank) => set({ soundBank: newBank }),
      setSfxBankAndReady: (keys) => set({ sfxBank: keys, ready: true }),
      setMusicBankAndReady: (newMusicBank) =>
        set({ musicBank: newMusicBank, musicReady: true }),

      setSfxVolume: (value) => set({ sfxVolume: value }),

      setMusicVolume: (volume) => {
        set({ musicVolume: volume });
        // only update the AudioManager if we're not muted
        if (!get().isMusicMuted && AudioManager.setMusicVolume) {
          AudioManager.setMusicVolume(volume);
        }
      },

      // stop / resume your background music when muting / un‐muting
      toggleMusicMute: () => {
        set((state) => {
          const nowMuted = !state.isMusicMuted;
          if (nowMuted) {
            // mute: silence the music
            AudioManager.stopMusic?.();
          } else {
            // unmute: restore it at the current volume
            AudioManager.setMusicVolume?.(state.musicVolume);
          }
          return { isMusicMuted: nowMuted };
        });
      },
      toggleSfxMute: () => set((state) => ({ isSfxMuted: !state.isSfxMuted })),
    }),
    {
      name: "sounds-storage",
      storage: webStorage,
    }
  )
);
